@if (listing) {
<div class="listing-component"
     (infiniteScroll)="listing.increaseLimit()"
     [infinitScrollActive]="listing.hasMore">
    @for (model of listingAsProducts.models; track model.id) {
    <model [ngClass]="component.colspan || ''"
           [model]="model" />
    }
</div>
}